import React, { forwardRef, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { LinearProgress, Paper } from '@mui/material';

interface ScrollPageContainerProps {
    children: ReactNode;
    disabled?: boolean;
    maxWidth?: number;
    paddingY?: { sm?: number; md?: number };
    paddingX?: { sm?: number; md?: number };
    loading?: boolean;
}

const ScrollPageContainer = forwardRef<HTMLDivElement, ScrollPageContainerProps>(
    ({ children, disabled = false, maxWidth = 1500, paddingY = { sm: 0, md: 2 }, paddingX = { sm: 0, md: 10 }, loading = false }, ref) => {
        return (
            <div ref={ref} className="fx-c h-100 of-y-auto">
                {loading && <LinearProgress />}
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    sx={{ py: paddingY, px: paddingX, pointerEvents: disabled ? 'none' : 'auto' }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            maxWidth,
                            borderRadius: 0,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        {children}
                    </Box>
                </Box>
            </div>
        );
    }
);

export default ScrollPageContainer;
